<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>敏感词管理</p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="词库名"
          class="s-input separate"
          v-model="queryInfo.title"
        >
        <select
          class="s-select separate"
          v-model="queryInfo.status"
        >
          <option value="">选择发布状态</option>
          <option value="0">未发布</option>
          <option value="1">已发布</option>
        </select>
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
        <div
          class="add-btn"
          @click="showEditWindow('add')"
        >新建</div>
      </form>
      <div id="list">
        <table v-if="tableData.length">
          <tr class="l_header">
            <th>敏感词库名称</th>
            <th>新建人</th>
            <th>创建时间</th>
            <th>生效时间</th>
            <th>状态</th>
            <th>关键词数量</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.title}}</td>
            <td>{{item.creator.name}}</td>
            <td>{{item.created.substr(0, 10) }}</td>
            <td>{{item.pubDate.replace('T', ' ') }}</td>
            <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已发布' : '未发布' }}</td>
            <td>{{formatWords(item.words)}}</td>
            <td class="action">
              <a
                class="edit"
                href="javascript:;"
                @click="maintainWords(item)"
              >维护</a>
              <a
                class="edit"
                href="javascript:;"
                @click="querySingle(item.id)"
              >编辑</a>
              <a
                v-if="item.status==1"
                href="javascript:;"
                @click="unpublish(item.id)"
              >取消发布</a>
              <a
                v-if="item.status==0"
                class="publish"
                href="javascript:;"
                @click="publish(item.id)"
              >发布</a>
              <a
                class="delete"
                href="javascript:;"
                @click="askDelete(item.id)"
              >删除</a>
            </td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowEditWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">新建/编辑</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>名称:</span>
              <input
                type="text"
                v-model="formInfo.title"
              >
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideEditWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowMaintainWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">维护</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label">{{formMaintainInfo.title}}</span>
            </div>
            <div class="item">
              <textarea
                id=""
                style="width:100%;min-height:200px;resize:none"
                v-model="formMaintainInfo.words"
              ></textarea>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideMaintainWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveMaintainInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Info',
  components: {
    Pagination
  },
  data() {
    return {
      classShowEditWindow: {},
      classShowMaintainWindow: {},
      queryInfo: {
        page: 1,
        size: 10,
        title: '',
        status: ''
      },
      formInfo: {
        title: '',
        status: 0
      },
      formMaintainInfo: {
        title: '',
        words: ''
      },
      tableData: [],
      tableDataCount: 0

    }
  },
  // 计算属性
  computed: {
    localUser() {
      return this.$store.state.userInfo
    },
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    formatWords(val) {
      if (val) {
        const str = val.split('\n')
        return str.length
      } else {
        return 0
      }
    },
    getCurrentTime() {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const hh = new Date().getHours()
      const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      _this.gettime = yy + '-' + mm + '-' + dd + 'T' + hh + ':' + mf + ':' + ss
      return _this.gettime
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/sensitiveword/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: id,
          title: data.title,
          creator_id: data.creator_id
        }
        this.showEditWindow('edit')
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！')
      })
    },
    // 提交信息
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$layer.msg('请输入名称!')
        return false
      }
      if (this.formInfo.id) {
        const url = '/sensitiveword/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$layer.msg('修改成功！')
            this.hideEditWindow()
            this.search()
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      } else {
        this.formInfo.creator_id = this.localUser.profile_id
        this.formInfo.pubDate = this.getCurrentTime()
        await this.$http.post('/sensitiveword/', this.formInfo).then((data) => {
          if (data.id) {
            this.$layer.msg('添加成功！')
            this.hideEditWindow()
            this.search()
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      }
    },
    async saveMaintainInfo() {
      if (!this.formMaintainInfo.words) {
        this.$layer.msg('请输入敏感词!')
        return false
      }
      const url = '/sensitiveword/' + this.formMaintainInfo.id + '/'
      await this.$http.put(url, this.formMaintainInfo).then((data) => {
        if (data.id) {
          this.$layer.msg('修改成功！')
          this.hideMaintainWindow()
          this.search()
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async search() {
      await this.$http.get('/sensitiveword/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 取消发布
    unpublish(id) {
      this.$parent.showConfirm('确定要取消发布吗？', () => {
        this.askRelease(id, 0)
      })
    },
    // 发布
    publish(id) {
      this.$parent.showConfirm('确定要发布吗？', () => {
        this.askRelease(id, 1)
      })
    },
    // 发布
    async askRelease(id, status) {
      const msg = status === 0 ? '取消' : ''
      const url = '/sensitiveword/' + id + '/'
      await this.$http.put(url, {
        status: status
      }).then((data) => {
        this.$layer.msg(msg + '发布成功！')
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg(msg + '发布失败！')
      })
    },
    // 删除
    async askDelete(id) {
      const url = '/sensitiveword/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$layer.msg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('删除失败！')
        })
      })
    },
    showEditWindow(value) {
      if (value === 'add') {
        this.formInfo = {
          title: '',
          status: 0
        }
      }
      this.classShowEditWindow = { visibility: 'visible' }
    },
    hideEditWindow() {
      this.classShowEditWindow = { visibility: 'hidden' }
    },
    // 维护
    async maintainWords(item) {
      const url = '/sensitiveword/' + item.id + '/'
      await this.$http.get(url).then((data) => {
        this.formMaintainInfo = {
          id: data.id,
          title: data.title,
          words: data.words
        }
        this.classShowMaintainWindow = { visibility: 'visible' }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！')
      })
    },
    hideMaintainWindow() {
      this.classShowMaintainWindow = { visibility: 'hidden' }
    },
    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }

  },
  mounted() {
    this.search()
  }
}
</script>
<style lang="less" scoped>
</style>
